import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CallStatsOutcomeRow } from "@/services/callStatsService";
import DonutBreakdown from "./DonutBreakdown";

interface OutcomeChartProps {
  rows: CallStatsOutcomeRow[];
}

const OutcomeChart = ({ rows }: OutcomeChartProps) => {
  const items = rows
    .filter((row) => row.outcome !== "")
    .map((row) => ({ name: row.outcome, value: row.calls }));
  const withOutcome = items.reduce((acc, item) => acc + item.value, 0);
  const allCalls = rows.reduce((acc, row) => acc + row.calls, 0);
  const pct = allCalls > 0 ? Math.floor((withOutcome / allCalls) * 100) : 100;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Call outcomes</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <DonutBreakdown
          items={items}
          unitLabel="calls"
          emptyText="No outcomes recorded in this range"
        />
        {withOutcome > 0 && pct < 100 && (
          <p className="text-xs text-muted-foreground">
            outcome recorded for {pct}% of calls in range
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default OutcomeChart;
